module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../~/axios/index.js
// module id = 620
// module chunks = 0